import { Injectable } from '@angular/core';
import { ProductListApiService } from '@epicuro-next/data/engagement/engagement-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map } from 'rxjs/operators';

import {
  changeProductOrderInListEntity,
  changeProductOrderInListEntitySuccess,
} from '../list-entities.actions';

@Injectable()
export class ListEntitiesProductsEffects {
  constructor(
    private actions$: Actions,
    private productListApi: ProductListApiService,
  ) {}

  public reorderProductInOpenedList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(changeProductOrderInListEntity),
      concatMap(({ listId, productId, brandId, order }) => {
        return this.productListApi
          .reorderProduct({
            productListId: listId,
            productId,
            brandId,
            order: order + 1,
          })
          .pipe(
            map(() =>
              changeProductOrderInListEntitySuccess({
                listId,
                productId,
                order,
                brandId,
              }),
            ),
          );
      }),
    ),
  );
}
